<template>
  <div>
    <div class="titleh1"><code />地址信息</div>
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      class="demo-ruleForm"
      disabled
    >
      <el-form-item label="托运人">
        <el-input v-model="form.createdByName" placeholder />
      </el-form-item>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="装货地址" style="margin-right: 15px">
              <el-input v-model="form.shipperAddress" placeholder="装货地址" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-input
              v-model="form.shipperDetailAddress"
              placeholder="装货详细地址"
            />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="卸货地址" style="margin-right: 15px">
              <el-input v-model="form.consigneeAddress" placeholder="卸货地" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-input
              v-model="form.consigneeDetailAddress"
              placeholder="卸货详细地址"
            />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="发货联系人" style="margin-right: 15px">
              <el-input
                v-model="form.shipperName"
                placeholder="发货联系人姓名"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-input v-model="form.shipperPhone" placeholder="发货联系电话" />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple" style="margin-right: 15px">
            <el-form-item label="卸货联系人">
              <el-input
                v-model="form.consigneeName"
                placeholder="卸货联系人姓名"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-input
              v-model="form.consigneePhone"
              placeholder="卸货联系电话"
            />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="里程数" style="margin-right: 15px">
              <el-input v-model="form.distance" placeholder="里程数" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1"><code />货物信息</div>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="货物名称" prop="name">
              <el-input v-model="form.coalTypeName" placeholder="货物名称" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="货物数量"
                    prop="name"
                    style="margin-right: 15px"
                  >
                    <el-input v-model="form.weight" placeholder="货物数量" />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-input v-model="form.coalUnitName" placeholder="单位" />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item
              label="货物单价"
              prop="name"
              style="margin-right: 15px"
            >
              <el-input v-model="form.coalPrice" placeholder="货物单价" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-select v-model="form.coalUnit" placeholder="请选择">
              <el-option label="元/吨" value="0" />
              <el-option label="元/方" value="1" />
              <el-option label="元/件" value="2" />
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item
              label="运费单价"
              prop="name"
              style="margin-right: 15px"
            >
              <el-input v-model="form.price" placeholder="运费单价" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-input v-model="form.isTrunkName" placeholder="运费单位" />
          </div>
        </el-col>

        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-row>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item label="合理耗损" style="margin-right: 15px">
                    <el-input
                      v-model="form.limitWastageAmount"
                      placeholder="合理耗损"
                    />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-input
                    v-model="form.limitWastageTypeName"
                    placeholder="损耗单位"
                  />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-row>
              <el-col :span="12">
                <el-form-item label="浮动费用" style="margin-right: 15px">
                  <el-input
                    v-model.number="form.driftPrice"
                    placeholder="请输入浮动费用"
                  >
                    <template slot="append"
                      >元</template
                    >
                  </el-input>
                  <!-- <el-input-number
                    style="width: 100%"
                    v-model="form.driftPrice"
                    placeholder="￥0.00"
                  >
                    <template slot="append">元</template>
                  </el-input-number> -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="0">
                  <div class="radio_box">
                    <div
                      class="each_radio"
                      :class="{
                        sel_radio_ashes: form.isOrderReturn == '1',
                        radio_un: form.isOrderReturn != '1'
                      }"
                    />
                    <span :style="'cursor: no-drop;'">需要回单</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-col>

        <!-- <el-col v-if="hasTreeOpen == 1" :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="所属行业">
              <el-input v-model="form.industryName" />
            </el-form-item>
          </div>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="运费抹零" prop="name">
              <!-- <el-input
                v-model="form.freightRoundingType"
                placeholder="运费单价"
              /> -->
              <el-select
                v-model="form.freightRoundingType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in optionsfreightRoundingType"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col v-if="form.vendorName" :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="供应商" prop="vendorName">
              <el-input v-model="form.vendorName" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1"><code />时间要求</div>
      <el-row v-if="form.coalNumber < 2">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="装车时间" prop="date1">
              <div class="block">
                <el-input
                  v-model="form.lastLoadingTime"
                  placeholder="装车时间"
                />
              </div>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="卸车时间" prop="date1">
              <div class="block">
                <el-input
                  v-model="form.lastUnloadingTime"
                  placeholder="卸车时间"
                />
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="form.coalNumber > 1">
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="货源有效期" prop="date1">
              <div class="block">
                <el-input
                  v-model="form.lastUnloadingTime"
                  placeholder="货源有效期"
                />
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1"><code />其他信息</div>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="指定司机">
              <el-input v-model="form.pushTargetName" placeholder />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="用车要求"
                    prop="name"
                    style="margin-right: 15px"
                  >
                    <el-input
                      v-model="form.pushVehicleUse"
                      style="width:100%;"
                      :disabled="true"
                    />
                  </el-form-item>
                </div>
              </el-col>
              <!-- <el-col :span="12">
                <div class="grid-content bg-purple-light">
                  <el-input v-model="form.carLength" :disabled="true" />
                </div>
              </el-col> -->
            </el-row>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="开票方式">
              <el-input v-model="form.billingTypeName" placeholder="开票方式" />
            </el-form-item>
          </div>
        </el-col> -->
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-form-item label="购买保险">
              <el-select v-model="form.insuranceCode" placeholder="请选择">
                <el-option
                  v-for="item in carneme"
                  :key="'carneme' + item.code"
                  :label="item.name"
                  :value="item.code"
                />
                <el-option label="不购买" value="8" />
              </el-select>
            </el-form-item>
          </div>
        </el-col> -->
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="上游客户">
              <el-input v-model="form.upstreamName" placeholder />
            </el-form-item>
          </div>
        </el-col> -->
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-form-item label="应收(元)">
              <el-input v-model="form.inFee" placeholder clearable />
            </el-form-item>
          </div>
        </el-col> -->
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="运输要求">
              <el-input v-model="form.coalName" placeholder clearable />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="运输方式" prop="transportType">
              <el-select v-model="form.transportType" placeholder="请选择">
                <el-option
                  v-for="item in optionsTs"
                  :key="'optionsTs' + item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="车数要求">
              <el-input
                v-model="form.coalNumber"
                placeholder="请输入车数要求（包车数量，5车）"
              />
            </el-form-item>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="允许报价">
              <el-radio v-model="form.isQuote" label="1"> 是 </el-radio>
              <el-radio v-model="form.isQuote" label="0"> 否 </el-radio>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-form-item label="最高价">
              <el-input v-model="form.maxPrice" placeholder clearable />
            </el-form-item>
          </div>
        </el-col>
        <el-col v-if="rainbowOnOff" :span="12">
          <el-form-item label="发布到云平台" label-width="136px">
            <el-radio v-model="form.isRainbowOn" :label="1"> 是 </el-radio>
            <el-radio v-model="form.isRainbowOn" :label="0"> 否 </el-radio>
          </el-form-item>
        </el-col> -->
      </el-row>
      <div class="titleh1"><code />费用信息</div>
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="预估司机费用" label-width="136px">
              <el-input
                v-model.number="form.dirverEstimatePay"
                placeholder="预估司机费用"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="预估托运人费用" label-width="136px">
              <el-input
                v-model.number="form.shipperEstimatePay"
                placeholder="预估托运人费用"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="预估托运人服务费" label-width="136px">
              <el-input
                v-model.number="form.serInfoPay"
                placeholder="预估托运人费用"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="付款方式" label-width="136px">
              <div class="pay-type-row">
                <div class="radio_box">
                  <div
                    class="each_radio"
                    style="cursor: no-drop"
                    :class="{
                      sel_radio_ashes: form.payType == '1',
                      radio_un: form.payType != '1'
                    }"
                  />
                  <span>预付</span>
                  <el-input
                    v-model="form.prePay"
                    placeholder="请输入金额"
                    step="0.01"
                    :disabled="form.payType != '1'"
                  >
                    <template slot="append"
                      >元</template
                    >
                  </el-input>
                </div>
                <div class="radio_box">
                  <div
                    class="each_radio"
                    style="cursor: no-drop"
                    :class="{
                      sel_radio_ashes: form.arrivePayType == '1',
                      radio_un: form.arrivePayType != '1'
                    }"
                  />
                  <span>到付</span>
                  <el-input
                    v-model="form.arrivePay"
                    placeholder="请输入金额"
                    step="0.01"
                    :disabled="form.arrivePayType != '1'"
                  >
                    <template slot="append"
                      >元</template
                    >
                  </el-input>
                </div>
                <div class="radio_box">
                  <div
                    class="each_radio"
                    style="cursor: no-drop"
                    :class="{
                      sel_radio_ashes: form.returnPayType == '1',
                      radio_un: form.returnPayType != '1'
                    }"
                  />
                  <span>回单付</span>
                  <el-input
                    v-model="form.returnPay"
                    placeholder="请输入金额"
                    step="0.01"
                    :disabled="form.returnPayType != '1'"
                  >
                    <template slot="append"
                      >元</template
                    >
                  </el-input>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="计划配油气额度" label-width="136px">
              <el-input v-model.number="form.oilFee" placeholder="">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="预估优惠服务费" label-width="136px">
              <el-input v-model.number="form.discountServiceFee" placeholder="">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="form.qrCodeOnOff == '1'" class="titleh1"><code />货源二维码</div>
    <el-form v-if="form.qrCodeOnOff == '1'">
      <el-row>
        <el-col :span="8">
          <div>
            <vue-easy-print ref="loadingQrPrint" table-show>
              <div class="img-box">
                <div class="qrCode">装货二维码</div>
                <el-image
                  style="width: 300px; height: 300px"
                  :src="form.loadingQr"
                  :preview-src-list="[form.loadingQr]"
                />
              </div>
            </vue-easy-print>
            <el-button style="margin-left: 35%" @click="printLoadingQrBtn()"
              >打印</el-button
            >
          </div>
        </el-col>
        <el-col :span="8" style="margin-left: 3%">
          <div>
            <vue-easy-print ref="unloadingQrPrint" table-show>
              <div class="img-box">
                <div class="qrCode">卸货二维码</div>
                <el-image
                  style="width: 300px; height: 300px"
                  :src="form.unloadingQr"
                  :preview-src-list="[form.unloadingQr]"
                />
              </div>
            </vue-easy-print>
            <el-button style="margin-left: 38%" @click="printUnloadingQrBtn()"
              >打印</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="titleh1"><code />运输单详情</div>
    <vxe-table
      border
      show-header-overflow
      show-overflow
      highlight-hover-row
      :data="tableData"
    >
      <vxe-table-column
        field="mainOrderNumber"
        title="货源单号"
        show-header-overflow
        show-overflow
        min-width="200"
        sortable
      />
      <vxe-table-column
        field="orderCode"
        title="运输单号"
        show-header-overflow
        show-overflow
        min-width="200"
        sortable
      />
      <vxe-table-column field="shipmentName" min-width="120" title="下单人" />
      <vxe-table-column
        field="orderGmtCreated"
        min-width="200"
        title="下单时间"
      />
      <vxe-table-column field="vehicleLicense" min-width="120" title="车牌号" />
      <vxe-table-column field="driverName" min-width="120" title="司机" />
      <vxe-table-column field="teamName" min-width="120" title="车队" />

      <vxe-table-column field="driverPhone" min-width="120" title="司机电话">
        <template v-slot="{ row }">
          <div>
            {{ row.teamPhone ? row.teamPhone : row.driverPhone }}
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="gmtCreated" min-width="200" title="接单时间" />
      <vxe-table-column field="fillTime" min-width="200" title="装货时间" />
      <vxe-table-column field="signTime" min-width="200" title="签收时间" />
      <vxe-table-column
        field="status"
        :formatter="formatterStatus"
        title="订单状态"
        min-width="130"
        sortable
      />
      <vxe-table-column
        field="deleted"
        :formatter="formatterDeleted"
        title="取消状态"
        min-width="130"
        sortable
      />
      <vxe-table-column title="操作" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <vxe-button type="text" @click="orderDesil(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="700"
      resize
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
  </div>
</template>
<script>
// import { regionDataPlus } from 'element-china-area-data'
import ordergoods from "@/components/WaybillDetails";
import {
  OrderDetails,
  insuranceType,
  isTreeOpen,
  isRainbowOn
} from "@/api/orderform";
import { orderDetailList } from "@/api/transport";
import vueEasyPrint from "vue-easy-print";
import { getListDict } from "@/api/shipment";
export default {
  components: {
    vueEasyPrint,
    ordergoods
  },
  data() {
    return {
      optionsfreightRoundingType: [
        {
          code: 0,
          name: "保留小数"
        },
        {
          code: 1,
          name: "抹除小数"
        },
        {
          code: 2,
          name: "抹除个位"
        },
        {
          code: 3,
          name: "抹除十位"
        },
        {
          code: 4,
          name: "向下取整到5的倍数"
        }
      ],
      rainbowOnOff: true,
      optionsTs: [],
      tuteship: false,
      hasTreeOpen: "",
      listQuery: {
        mainOrderCode: "",
        isCancel: "",
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      Pagingconf: [],
      form: {
        name: "",
        createdByName: "",
        consigneeAddress: "",
        consigneeDetailAddress: "",
        gmtCreated: "",
        gmtModified: "",
        dfName: "",
        dfPhone: "",
        shipperAddress: "",
        shipperDetailAddress: "",
        shipperName: "",
        shipperPhone: "",
        coalBigTypeName: "",
        coalUnitName: "",
        isQuote: "0",
        isRainbowOn: 0,
        loadingQr: "",
        unloadingQr: "",
        qrCodeOnOff: ""
      },
      branchCode: "",
      tableData: [],
      carneme: [],
      instype: {
        type: "insureType1"
      }
    };
  },
  created() {
    this.getDict();
    this.getRainbowOnOrOff();
    isTreeOpen().then(res => {
      this.hasTreeOpen = res.data;
    });
  },
  mounted() {},
  methods: {
    // 云平台选择开关
    getRainbowOnOrOff() {
      isRainbowOn({ branchCode: this.branchCode }).then(res => {
        this.rainbowOnOff = res.data;
      });
    },
    getDict() {
      getListDict({ types: "transportType" }).then(response => {
        this.optionsTs = response.data[0].dictList;
      });
    },
    Getdetails(code) {
      this.listQuery.mainOrderCode = code;
      OrderDetails(code).then(response => {
        this.form = response.data;
        this.form.coalNumber = response.data.coalNumber || "不限";
        this.form.coalName = response.data.coalName || "暂无";
        this.branchCode = response.data.order.branchCode;
        this.Insurance();
      });
      this.findList();
    },
    findList() {
      orderDetailList(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total
          ? (this.Pagingconf = [20, 30, 50, 100, response.data.total])
          : (this.Pagingconf = [20, 30, 50, 100]);
      });
    },
    orderDesil(c) {
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    },
    printLoadingQrBtn() {
      this.$refs.loadingQrPrint.print();
    },
    printUnloadingQrBtn() {
      this.$refs.unloadingQrPrint.print();
    },
    formatterDeleted({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未取消";
        case 1:
          return "已取消";
        default:
          break;
      }
    },
    // 订单状态（与运单管理 statusOptions 一致）
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未接单";
        case 1:
          return "已接单";
        case 2:
          return "已装货";
        case 3:
          return "已卸货";
        case 4:
          return "已核算";
        case 5:
          return "部分支付";
        case 6:
          return "已打款";
        default:
          break;
      }
    },
    // 查询保险
    Insurance() {
      if (this.branchCode) {
        this.instype.branchCode = this.branchCode;
        insuranceType(this.instype).then(response => {
          this.carneme = response.data.records;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.img-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  position: relative;
  top: 20%;
}
.qrCode {
  font-size: 18px;
}
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
.el-autocomplete {
  width: 81%;
}
</style>
<style lang="scss">
.el-picker-panel.no-atTheMoment {
  .el-button--text.el-picker-panel__link-btn {
    display: none;
  }
}

.operate_box {
  display: flex;
  justify-content: space-between;
  .frequent {
  }
  .notice {
    margin-top: 50px;
    margin-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .operate_one {
    display: flex;
    align-items: center;
  }
  .operate_two {
  }
}
.pay-type-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  .radio_box {
    flex: 0 0 auto;
    margin-right: 16px;
    &:last-child {
      margin-right: 0;
    }
    span {
      white-space: nowrap;
      flex-shrink: 0;
    }
    .el-input {
      flex: none;
      width: 160px;
    }
  }
}
.radio_box {
  display: flex;
  align-items: center;
  .each_radio {
    width: 13px;
    height: 13px;
    flex-shrink: 0;

    border-radius: 13px 13px 13px 13px;
    cursor: pointer;
    box-sizing: border-box;
    margin-right: 12px;
  }
  .each_radio_block {
    border-radius: 0;
  }
  .radio_un {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid #dcdcdc;
  }
  .sel_radio {
    background: rgba(255, 255, 255, 0.9);
    border: 4px solid #4186ef;
  }
  .sel_radio_ashes {
    background: rgba(255, 255, 255, 0.9);
    border: 5px solid #dfe4ed;
  }
  .el-input {
    margin-left: 10px;
    flex: 1;
    min-width: 0;
    width: auto;
  }
}
.positive_negative {
  display: flex;
  .positive_btn {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #d4d4d4;
    color: #ffffff;
    cursor: pointer;
  }
  .negative_btn {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4186ef;
    color: #ffffff;
  }
}

.estimated {
  flex: none;
  width: 192px;
  height: 40px;
  background: #f5fcff;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #89b8ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  box-sizing: border-box;
  .carriage {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 12px;
    color: #333333;
  }
  .money {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 22px;
    color: #4186ef;
    display: flex;
    align-items: flex-end;
    .money_unit {
      font-weight: 400;
      font-size: 16px;
      color: #4186ef;
    }
  }
}
</style>
